export const SHOW_TOURNAMENTS_BANNER_FOR_ALL_EVENTS =
    'SHOW_TOURNAMENTS_BANNER_FOR_ALL_EVENTS'
export const SHOW_TOURNAMENTS_BANNER_FOR_EVENT =
    'SHOW_TOURNAMENTS_BANNER_FOR_EVENT'
/**
 * Hide tournaments banner from all events
 *
 * @param {Object} state
 * @return {{showTournamentsBanner: *}}
 */
function showTournamentsBannerForAllEvents(state) {
    return {
        ...state,
        status: false,
    }
}

/**
 * Hide tournaments banner for a particular event
 *
 * @param {Object} state
 * @param {number} data
 * @return {hideTournamentsBannerForEvents:*}}
 */
function showTournamentsBannerForEvent(state, data) {
    return {
        ...state,
        hideTournamentsBannerForEvents: [data, ...state.hideTournamentsBannerForEvents],
    }
}

/**
 * Reducer for tournament banner status
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch (action.type) {
        case SHOW_TOURNAMENTS_BANNER_FOR_ALL_EVENTS:
            return showTournamentsBannerForAllEvents(state)
        case SHOW_TOURNAMENTS_BANNER_FOR_EVENT:
            return showTournamentsBannerForEvent(state, action.data)
        default:
            return state
    }
}
